export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte obchod"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bez názvu"])}
}